import React, {useState} from 'react';
import {SuggestChip} from 'app/components/admin/SuggestChip';
import {SuggestOption} from 'app/components/admin/SuggestOption';
import {TextField} from '@mui/material';
import {Autocomplete} from '@mui/material';
import {getSearch} from 'app/services/api';
import {array, bool, func, string} from 'prop-types';

const AutocompleteWrapper = ({error, helperText, label, onValueChange, onValueDelete, values}) => {
  const [results, setResults] = useState([]);

  const searchPlayers = (query) => {
    return getSearch(query).then((response) => {
      // For cancel axios calls, response is undefined
      if (response) {
        setResults(response.data);
      }
    });
  };

  return (
    <Autocomplete
      multiple
      filterSelectedOptions
      disableClearable
      value={values}
      options={results}
      onChange={onValueChange}
      renderTags={(values) =>
        values.map((value) => <SuggestChip key={value.slug} onDelete={onValueDelete} input={value} />)
      }
      renderOption={(props, option) => <SuggestOption result={option} {...props} />}
      filterOptions={(option) => option}
      onInputChange={(ev, val) => searchPlayers(val)}
      renderInput={(params) => (
        <TextField {...params} label={label} variant='standard' error={error} helperText={helperText} />
      )}
    />
  );
};

AutocompleteWrapper.propTypes = {
  error: bool,
  helperText: string,
  label: string,
  onValueChange: func.isRequired,
  onValueDelete: func.isRequired,
  values: array.isRequired,
};

export {AutocompleteWrapper};
